import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { tieuDeBaoCaoApi } from "../../../api/category/tieuDeBaoCaoApi";
import { toLowerCaseDeep } from "../../../utils/toLowerCaseDeep";
import { rootActions } from "../../actions/rootActions";
import { eTieuDeBaoCaoActionIds, ITieuDeBaoCaoActionTypes } from "../../action-types/category/ITieuDeBaoCaoActions";
import { ITieuDeBaoCao } from "../../../model/response/category/ITieuDeBaoCao";
const mainAction= rootActions.category.tieuDeBaoCao;

export function* tieuDeBaoCaoSaga(): any {
    yield takeLatest(eTieuDeBaoCaoActionIds.LOAD_START, loadWorker);
    yield takeEvery(eTieuDeBaoCaoActionIds.SAVE_START, saveWorker);
    yield takeEvery(eTieuDeBaoCaoActionIds.DELETE_START, deleteWorker);
}

function* loadWorker(action: ITieuDeBaoCaoActionTypes): any {
    const res = yield call(tieuDeBaoCaoApi.SelectByUserId, action.payload as string);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.LOAD_ERROR(res.message ?? "Có lỗi khi tải tiêu đề báo cáo"));
    }
}

function* saveWorker(action: ITieuDeBaoCaoActionTypes): any {
    let res;
    const payload = action.payload as ITieuDeBaoCao;
    if (payload.id > 0) {
        res = yield call(tieuDeBaoCaoApi.Update, payload);
    } else {
        res = yield call(tieuDeBaoCaoApi.Insert, payload);
    }
    if (res.is_success) {
        yield put(mainAction.SAVE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.SAVE_ERROR(res.message ?? "Có lỗi khi lưu tiêu đề báo cáo"));
    }
}

function* deleteWorker(action: ITieuDeBaoCaoActionTypes): any {
    const id = action.payload as string;
    const res = yield call(tieuDeBaoCaoApi.DeleteByUserId, id);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(toLowerCaseDeep(res.data)));
    } else {
        yield put(mainAction.DELETE_ERROR(res.message ?? "Có lỗi khi xóa tiêu đề báo cáo"));
    }
}